module.exports = __webpack_public_path__ + "img/paladin.b2ee3486.png";